module.exports = __webpack_public_path__ + "img/upperabs-endomorph-female.88ad8cc7.svg";